/* eslint-disable */
/*! jQuery.newWin */
(function($){$.fn.newWin=function(){return this.each(function(){if((this.protocol=='http:'||this.protocol=='https:')&&this.hostname!=location.hostname){$(this).click(function(){open(this.href);return false;});}});};})(jQuery);
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/plugins/jquery.newWin.js